import { IBreadcrumbItem } from '@/interfaces/gfpaReport.interface'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import Link from '@mui/material/Link'
import React from 'react'

export type IBreadcrumb = {
  items: IBreadcrumbItem[]
  handleBreadcrumbClick: Function
}
const Breadcrumb: React.FC<IBreadcrumb> = ({
  items,
  handleBreadcrumbClick,
}) => {
  return (
    <Breadcrumbs aria-label='breadcrumb' sx={{ fontSize: '0.875rem' }}>
      {items.map((item, index) => {
        const isLast = index === items.length - 1
        return (
          <Link
            key={index}
            color={isLast ? 'secondary' : 'primary'}
            component='button'
            onClick={() => handleBreadcrumbClick(item)}
            sx={{
              cursor: isLast ? 'initial' : 'pointer',
              pointerEvents: isLast ? 'none' : 'initial',
              textDecoration: isLast ? 'none' : 'inherit',
            }}
            disabled={isLast}
          >
            {item.label}
          </Link>
        )
      })}
    </Breadcrumbs>
  )
}

export default Breadcrumb
